import script from "./PlotExpensesBlock.vue?vue&type=script&setup=true&lang=js"
export * from "./PlotExpensesBlock.vue?vue&type=script&setup=true&lang=js"

import "./PlotExpensesBlock.vue?vue&type=style&index=0&id=2d7fc613&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2d7fc613"]])

export default __exports__